__turbopack_context__.v({
  "breadcrumb": "Breadcrumbs-module__W12ClG__breadcrumb",
  "root": "Breadcrumbs-module__W12ClG__root",
});
